import {JSONSchema7} from "json-schema";

const EditedBySimpleTextSchema = async () => {
    let schema: JSONSchema7 = {
        title: "EditedBySimpleTextSchema",
        type: "object",
        //
        definitions: {}
    };
    //
    schema = {
        properties: {
            className: {
                type: "string",
            },
            displayCount: {
                type: "number"
            }
        },
        //
        ...schema
    }
    //
    return schema;
}

export default EditedBySimpleTextSchema;